import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import styles from './Analytics.module.css';
import Header from '../Header';
import ChevronRightIcon from '../svgs/ChevronRightIcon';
import {formatNumberForAnalytics} from '../../../../shared/utils/Helpers';

export class WorkSpaceAnalytics extends Component {
  constructor(props) {
    super(props);
  }

  statbox = (label, value) => {
    return (
      <div className={[styles.statbox]}>
        <h2>{value}</h2>
        <p>{label}</p>
      </div>
    );
  };

  navigateChallengeWorkSpace = (title) => {
    this.props.history.push({
      pathname: '/challengeworkspaceanalytics',
      state: {
        workspaceData: this.props.location.state.workSpace,
        titleName: title,
        startDate: this.props.location.state.startDate,
        endDate: this.props.location.state.endDate,
      },
    });
  };
  render() {
    const {workSpace} = this.props.location.state;
    const totalChallengesParticipants = workSpace.challenges.reduce(
      (sum, current) => sum + current.total_participants,
      0,
    );
    const totalEventsAttendees = workSpace.events.reduce(
      (sum, current) => sum + current.total_attendees,
      0,
    );
    const {history} = this.props;

    return (
      <>
        <Header
          title={workSpace.workspace_name}
          onBack={() => {
            history.goBack();
          }}
        />
        <div className={[styles.contentContainer]}>
          <div
            className={styles.analyticsBlock}
            onClick={() => this.navigateChallengeWorkSpace('Users')}>
            <h1 className={[styles.analyticsHeader]}>
              Users
              <ChevronRightIcon />
            </h1>
            <div className={styles.statsContainer}>
              {this.statbox(
                'Total Users',
                formatNumberForAnalytics(workSpace.total_registrations),
              )}
              {this.statbox(
                '30 day Active Users',
                formatNumberForAnalytics(workSpace.active_users_last_30_days),
              )}
              {this.statbox(
                'Steps Logged',
                formatNumberForAnalytics(workSpace.total_steps),
              )}
              {this.statbox(
                'Miles Tracked',
                formatNumberForAnalytics(workSpace.total_miles),
              )}
            </div>
          </div>

          <div
            className={styles.analyticsBlock}
            onClick={() => this.navigateChallengeWorkSpace('Challenges')}>
            <h1 className={[styles.analyticsHeader]}>
              Challenges
              <ChevronRightIcon />
            </h1>
            <div className={styles.statsContainer}>
              {this.statbox(
                'Challenges Joined',
                formatNumberForAnalytics(totalChallengesParticipants),
              )}
              {this.statbox(
                'Badges Earned',
                formatNumberForAnalytics(workSpace.total_badges),
              )}
            </div>
          </div>

          <div
            className={styles.analyticsBlock}
            onClick={() => this.navigateChallengeWorkSpace('Events')}>
            <h1 className={[styles.analyticsHeader]}>
              Events
              <ChevronRightIcon />
            </h1>
            <div className={styles.statsContainer}>
              {this.statbox(
                'Total Attendees',
                formatNumberForAnalytics(totalEventsAttendees),
              )}
              {this.statbox(
                'Check-Ins',
                formatNumberForAnalytics(workSpace.total_checkins),
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(WorkSpaceAnalytics);
